<template>
  <div class="removeDust_historicalTrend _boxBg_dark_big absolute_center">
    <div class="selfClose_btn" @click="close"></div>
    <div class="_boxTitle">
      脱硫脱硝除尘系统实时监控
    </div>
    <div class="_blueLine"></div>
    <el-row>
      <el-col :span="24" :style="{ textAlign: 'center',marginTop: '10px'}">
        <div class="dot1">•</div>
        <div class="dot1-title">≤80%限值</div>

        <div class="dot2">•</div>
        <div class="dot1-title">＞80%限值且≤限值</div>

        <div class="dot3">•</div>
        <div class="dot1-title">＞限值</div>
      </el-col>
    </el-row>
    <div class="_innerBox">
      <ul class="outUl">
        <li class="outLi" style="width:1144px">
          <div class="li_title">炼铁部</div>
          <div class="li_content">
            <ul class="inUl">
              <li class="inLi" v-for="(item,i) in dashboardData['炼铁部']" :key="i">
                <circle-bar :circleData="
               item.list[0]" />
              </li>
            </ul>
          </div>
        </li>
        <li class="outLi" style="width:960px">
          <div class="li_title">炼钢部</div>
          <div class="li_content">
            <ul class="inUl">
              <li class="inLi" v-for="(item,i) in dashboardData['炼钢部']" :key="i">
                <circle-bar :circleData="
                item.list[0]" />
              </li>
            </ul>
          </div>
        </li>
        <li class="outLi" style="width:300px">
          <div class="li_title">智新电磁</div>
          <div class="li_content">
            <ul class="inUl">
              <li class="inLi" v-for="(item,i) in dashboardData['智新电磁']" :key="i">
                <circle-bar :circleData="
                item.list[0]" />
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import getOpt from "./chartOpt.js";
import { unwarp } from "@/utils/tools.js";
import circleBar from "./../circle.vue";

export default {
  title: "除尘系统颗粒实时监控",
  props: ["globalInstance"],
  setup(props) {
    const globalInstance = props.globalInstance;
    return { globalInstance };
  },
  components: { circleBar },
  data() {
    return {
      customerId: this.globalInstance.$store.state.customerId,
      paramsData: {
        customerId: 8,
        type: 3,
      },
      dashboardData: {},
      INTERVAL: null,
      curList: [],
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    getColor() {
      return function (value, standard_data) {
        if (Number(value) <= 0.8 * Number(standard_data)) {
          return "blue";
        } else if (
          Number(value) > 0.8 * Number(standard_data) &&
          Number(value) <= Number(standard_data)
        ) {
          return "yellow";
        } else {
          return "red";
        }
      };
    },
  },
  methods: {
    formatDateTime(inputTime) {
      inputTime = parseInt(inputTime);
      if (inputTime) {
        var date = new Date(inputTime);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? "0" + minute : minute;
        second = second < 10 ? "0" + second : second;
        return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
      }
    },
    async getData() {
      if (this.INTERVAL) {
        clearTimeout(this.INTERVAL);
        this.INTERVAL = null;
      }
      let getQgDevicesByType =
        CONFIG.requestName + this.globalInstance.$apiOpt.getQgDevicesByType;
      let data = await this.globalInstance.$apiUtils.get(
        getQgDevicesByType,
        this.paramsData
      );
      this.dashboardData = data;
      this.INTERVAL = setTimeout(() => {
        this.getData();
      }, 30 * 1000);
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.removeDust_historicalTrend {
  width: calc(67% + 70px) !important;
  ._innerBox {
    overflow: auto;
    ul.outUl {
      width: 93%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      li.outLi {
        width: calc((100% - 80px) / 3);
        height: 100%;
        margin: 0 5px;
        .li_title {
          height: 50px;
          font-size: 26px;
          font-weight: 500;
          color: #dddddd;
          line-height: 50px;
          text-align: center;
          background: rgba(1, 18, 43, 0.81);
          border: 1px solid rgba(132, 170, 255, 0.5);
          border-left: 0px;
          border-right: 0px;
        }
        .li_content {
          min-height: 634px;
          background: linear-gradient(
            180deg,
            rgba(108, 151, 255, 0.2) 0%,
            rgba(107, 151, 255, 0.2) 78%,
            rgba(58, 116, 255, 0.1) 100%
          );
          ul.inUl {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            text-decoration: none;
            padding: 30px;
            li.inLi {
              margin: 10px 8px;
              display: inline-block;
              width: 164px;
              height: 168px;
              background: rgba(0, 0, 0, 0.2);
              box-shadow: 0px 1px 1px 0px rgba(46, 130, 255, 0.41);
              border: 1px solid;
              border-image: linear-gradient(
                  90deg,
                  rgba(46, 74, 117, 1),
                  rgba(46, 130, 255, 0),
                  rgba(1, 191, 165, 0)
                )
                1 1;
            }
          }
        }
      }
    }
  }
}

.dot1 {
  font-size: 60px;
  color: #99f5ffff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
}

.dot2 {
  font-size: 60px;
  color: #f5a623;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot3 {
  font-size: 60px;
  color: #ff7f7fff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot1-title {
  font-size: 16px;
  font-family: "fontNormal";
  color: #c8dde1ff;
  display: inline-block;
  line-height: 50px;
  height: 40px;
}
</style>
<style type="text/css">
._boxBg_dark .el-form-item__label {
  color: #99f5ff !important;
  font-weight: 500;
}
._boxBg_dark .el-form-item__content {
  border-radius: 2px !important;
  border: 1px solid !important;
  border-image: linear-gradient(90deg, #2e31ff, #01b0bf) 1 1 !important;
}

._boxBg_dark ._boxBg_dark_select {
  height: 40px;
}

._boxBg_dark ._boxBg_dark_select .el-input__inner {
  font-size: 16px;
}
</style>